import React, { useEffect, useState, useRef } from "react";
import "./style.css";
import { useNavigate, Link } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { useSelector, useDispatch } from 'react-redux';
import { fetchData } from '../redux/apiSlice';
import { toastify, userlogout, clearuser } from "../redux/controller";
import Deleteicon from "../assets/trash.png";
import Xicon from "../assets/Delete Icon.svg"
import { format } from 'date-fns';

const colors = {
  orange: "#FFA500",
  grey: "#a9a9a9"
};

export default function Huntersreview() {


    const [userdata, setuserdata] = useState({});

  let Navigate = useNavigate();
  const dispatch = useDispatch()
  const initialized = useRef(false)
  const [loading, setloading] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [hoverValue, setHoverValue] = useState(undefined);
  const [hunterlist, sethunterlist] = useState([]);
  const [totalHunters, setTotalHunters] = useState(0);
  const [starrating, setstarrating] = useState(0);
  const [selectedhunter, setselectedhunter] = useState({});
  const stars = Array(5).fill(0);
  const usertoken = useSelector((state) => state.userdata.usertoken);
  const [stepinputField, setstepInputField] = useState({
    description: "",
    rating: ""
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [perpage, setPerPage] = useState(10);
  const [searchInput, setSearchInput] = useState("");
  const [reviewstatus, setReviewstatus] = useState(false);

  useEffect(() => {

    const userinfo = JSON.parse(localStorage.getItem('userdata'));
    if (userinfo) {
      setuserdata(userinfo);
    }

    if (!initialized.current) {
      initialized.current = true
      if (usertoken) {
        getreviewlist()
      }
    }
  }, []);

  useEffect(() => {
    getreviewlist(searchInput, currentPage);
  }, [currentPage, perpage]);

  const inputsHandler = (e) => {
    console.log(e.target.name);
    setstepInputField((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value
    }));
  };


  const handleSubmitPopup = async () => {

    var reviewlist = await dispatch(
      fetchData({
        apiurl: "/auth/user/addadminreview",
        description: stepinputField.description,
        rating: starrating,
        hunterid: selectedhunter._id,
        userid: userdata._id,
        headers: { "x-access-token": usertoken }
      })
    )
    console.log(reviewlist)
    if (reviewlist && reviewlist.payload && reviewlist.payload.status == 200) {
      getreviewlist(searchInput, currentPage);
      setstarrating(0)
      setstepInputField((prevState) => ({
        ...prevState,
        ['description']: ''
      }));
    }
    else {
      if (reviewlist.payload.response && reviewlist.payload.response.data && reviewlist.payload.response.data.message) {
        toastify({ message: reviewlist.payload.response.data.message })
      }
      if (reviewlist.payload.response.data.message == "Invalid token provided!" || reviewlist.payload.response.data.message == "No token provided!") {
        clearuser()
        userlogout()
        Navigate('/')
        window.location.reload()
      }
    }
    setPopupOpen(false);
  };

  async function getreviewlist(searchQuery = "", page = 1) {
    if (usertoken == null || usertoken.length < 1) {
      clearuser()
      userlogout()
      Navigate('/')
      window.location.reload()
      return
    }

    setloading(true)
    var reviewlist = await dispatch(
      fetchData({
        apiurl: "/auth/user/gethunterreviews",
        search: searchQuery,
        page: page,
        limit: perpage,
        headers: { "x-access-token": usertoken }
      })
    )
    setloading(false)
    if (reviewlist && reviewlist.payload && reviewlist.payload.status == 200) {
      sethunterlist(reviewlist.payload.hunters)
      setTotalHunters(reviewlist.payload.totalHunters)
    }
    else {
      sethunterlist([])
      if (reviewlist.payload.response && reviewlist.payload.response.data && reviewlist.payload.response.data.message) {
        if (reviewlist.payload.response.data.message === "Invalid token provided!" || reviewlist.payload.response.data.message === "No token provided!") {
          // toastify({ message: 'Session expired' });
          userlogout();
          Navigate('/');
        }
      }
    }
  }

  const handlestarClick = (data) => {
    setstarrating(data)
  }


  const handleMouseOver = (newHoverValue) => {
    setHoverValue(newHoverValue);
  };

  const handleMouseLeave = () => {
    setHoverValue(undefined);
  };

  const handleSearch = () => {
    sethunterlist([]);
    setloading(true)
    setCurrentPage(1);
    getreviewlist(searchInput, 1);
  };

  const inputperPage = (event) => {
    setPerPage(event.target.value);
    sethunterlist([]);
    setloading(true)
    setCurrentPage(1);
  };


  const handleClearSearch = () => {
    sethunterlist([]);
    setloading(true)
    setSearchInput("")
    setCurrentPage(1)
    getreviewlist('', 1);
    setTotalHunters(0)
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  function convertdate(date) {
    const d = new Date(date); // parse ISO string
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0'); // months are 0-based
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  }

  const handlereviewClick = (data) => {

    const hunterIndex = parseInt(data.target.id.split('_')[1]);
    const selectedHunter = hunterlist[hunterIndex];
    setselectedhunter(selectedHunter);

    const matchedReview = selectedHunter.review?.find(
      (rev) => rev.admin === userdata._id
    );

    if (matchedReview) {
      setstarrating(matchedReview.rating);
      setstepInputField((prevState) => ({
        ...prevState,
        description: matchedReview.description || ''
      }));
    } else {
      setstarrating(0);
      setstepInputField((prevState) => ({
        ...prevState,
        description: ''
      }));
    }

    setReviewstatus(data);
    setPopupOpen(true);
  };

  const handlePageClick = (selectedPage) => {
    console.log("Selected page ", selectedPage.selected + 1);
    setCurrentPage(selectedPage.selected + 1);
  };
  const handleClosePopup = () => {
    setPopupOpen(false);
  };


  return (
    <>
      <div className="hunter-main review">
        <div className="search-div">
          <div className="input-wrapper">
            <div className="search-of-review">
              <input
                type="text"
                className="form-control hunter-search"
                placeholder="Hunter Name, Email Address, Phone Number"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                name="searchInput"
                onKeyDown={handleKeyDown}
              />
              {searchInput && (
                <button className="clear-btn" onClick={handleClearSearch}>×</button>
              )}
            </div>
            <button className="add-btn" onClick={handleSearch}>Search</button>
          </div>

        </div>
        <div className="add-form pagination-table">
          <div className="add-table">
            <table className="table ">
              <thead>
                <tr>
                  <th scope="col">Hunter Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Phone Number</th>
                  <th scope="col">Account Created</th>
                  <th scope="col">Rating/Ranking</th>
                  <th scope="col">Review</th>
                </tr>
              </thead>
              <tbody style={{ display: hunterlist && hunterlist.length ? 'contents' : 'table-caption' }}>
                {loading ? (
                  // Show loading state
                <tr>
                    <td colSpan="6" style={{ textAlign: 'center', padding: '200px' }}>
                      Loading...
                    </td>
                  </tr>
                 
                ) : hunterlist && hunterlist.length > 0 ? (
                  // Show data when loaded and available
                  hunterlist.map((item, index) => {
                    const matchedReview = item.review?.find(
                      (rev) => rev.admin === userdata._id
                    );

                    return (
                      <tr key={item.id}>
                        <td>{item.firstname} {item.lastname}</td>
                        <td>{item.email}</td>
                        <td>{item.phonenumber}</td>
                        <td>
                          {item.createdAt ? convertdate(String(item.createdAt)) : ''}
                        </td>
                        <td>
                          <Link id={`writereview_${index}`} onClick={handlereviewClick}>
                            Write a review
                          </Link>
                        </td>
                        <td>
                          {[...Array(5)].map((_, i) => (
                            <FaStar
                              key={i}
                              size={24}
                              color={
                                matchedReview?.rating > i
                                  ? colors.orange
                                  : colors.grey
                              }
                            />
                          ))}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  // Show message when no data is available
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                      No hunters found.
                    </td>
                  </tr>
                )}
              </tbody>



            </table>
          </div>
          <div className="rowperpage">
            <div className="perpagecount">
              Row Per Page&nbsp;
              <select
                onChange={inputperPage}
                value={perpage}>
                <option value={10}>10</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={150}>150</option>
                <option value={200}>200</option>
              </select>
            </div>
            <ReactPaginate
              pageCount={Math.ceil(totalHunters / perpage)}
              pageRangeDisplayed={5}
              breakLabel={"..."}
              marginPagesDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={"pagination custom-pagination"}
              activeClassName={"active"}
            />
          </div>
        </div>

        <div className="hunter-popup">
          {popupOpen && (
            <div className="popup">
              <div className="popup-content">
                <i className="fa-solid fa-xmark" onClick={handleClosePopup}></i>

                {reviewstatus == true ? <h2>Review</h2> : <h2>Write A Review</h2>}
                <div className="start-div">
                  {stars.map((_, index) => {
                    return (
                      <FaStar
                        key={index}
                        size={24}
                        onClick={() => handlestarClick(index + 1)}
                        onMouseOver={() => handleMouseOver(index + 1)}
                        onMouseLeave={handleMouseLeave}
                        color={
                          starrating > index
                            ? colors.orange
                            : colors.grey
                        }
                        style={{
                          marginRight: 10,
                          cursor: "pointer"
                        }}
                      />
                    );
                  })}
                </div>
                <textarea
                  rows="4"
                  cols="50"
                  placeholder="Add your review..."
                  name="description"
                  onChange={inputsHandler}
                  value={stepinputField.description}
                ></textarea>
                <div className="hunter-btndiv">
                  <button className="cancel" onClick={handleClosePopup}>
                    Cancel
                  </button>
                  <button className="post" onClick={handleSubmitPopup}>
                    Post
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
